import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    //redirect:'/register'
    redirect:'/registro'
  },
  {
    path: '/app',
    redirect:'/app/dashboard'
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/layouts/main_auth'),
  },
  {
    path: '/registro',
    name: 'registro',
    component: () => import('../views/registro'),
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/layouts/main_layout'),
    children:[
      {
        path: '/register',
        name: 'register',
        component: () => import('../views/Register.vue')
      }
    ]
  },
  {
    path: '/app',
    name: 'app',
    component: () => import('../views/layouts/main_app'),
    meta:{
      requiresAuth: true
    },
    children:[
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('../views/App/Dashboard.vue')
      },
      {
        path: 'registrados',
        name: 'registrados',
        component: () => import('../views/App/ocimf')
      },
      {
        path: 'assistents',
        name: 'assistents',
        component: () => import('../views/App/Assistent.vue')
      }

    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next)=>{
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  //rquires auth && no user
  if(requiresAuth && !(await store.dispatch("user/getCurrentUser"))){
    next({name:"register"});
    //no requires auth and user (auth)
  }else if (!requiresAuth && (await store.dispatch("user/getCurrentUser"))){
    next({name:"registrados"});
  }else{
    next();
  }

})

export default router
